import {
  Directive,
  Input,
  OnInit,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { FeatureFlagsService } from '@web-frontend/shared/services/feature-flags/feature-flags.service';
import { StorageService } from '@web-frontend/shared/services/storage';
import * as configcat from 'configcat-js';

@Directive({
  selector: '[romaFeatureFlag]',
})
export class FeatureFlagDirective implements OnInit {
  @Input() romaFeatureFlag: string;
  @Input() romaFeatureFlagAttributes: {
    [key: string]: configcat.UserAttributeValue;
  };

  private hasView = false;

  constructor(
    private templateRef: TemplateRef<void>,
    private viewContainer: ViewContainerRef,
    private featureFlagsService: FeatureFlagsService
  ) {}

  ngOnInit(): void {
    this.resolveFlag();
  }

  static buildAttributes() {
    const companyData = JSON.parse(StorageService.companyData) || {};
    const companyCreatedAt = new Date(companyData.created_at) ?? new Date();

    const planId: string | undefined =
      companyData.lastPlanId || companyData.plans?.[0];

    const customAttributes = {
      companyCreatedAt: companyCreatedAt.getTime(),
      planId: planId ?? 'unknown',
    };

    return customAttributes;
  }

  private async resolveFlag(): Promise<void> {
    const customAttributes = FeatureFlagDirective.buildAttributes();
    const value = await this.featureFlagsService.getValue(
      this.romaFeatureFlag,
      false,
      { ...customAttributes, ...this.romaFeatureFlagAttributes }
    );

    if (value && !this.hasView) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.hasView = true;
    } else if (!value && this.hasView) {
      this.viewContainer.clear();
      this.hasView = false;
    }
  }
}
